var e={heading:"Something went wrong",subheading:"Please refresh the page and try again."};export{e as ERROR_BOUNDARY_MESSAGES};
//# sourceMappingURL=constants.js.map
